import React from "react";
import { Form } from "react-bootstrap";
import CamplaCoreService from "../../../../../../services/CamplaCoreService";
import ValidationHelper from "../../../../../../helpers/ValidationHelper";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../../../../components/dialogs/baseDialog/BaseDialog";
import BaseDatePicker from "../../../../../../components/baseDatePicker/BaseDatePicker";

class RenewTokenDialog extends React.Component {
  constructor(props) {
    super(props);
    this.validationDefinition = {
      expiration: {
        initValid: true,
        defaultValue: ValidationHelper.yearsFromNow(3),
        rule: (value) => ValidationHelper.isTokenExpirationDate(value),
      },
    };

    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition),
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation),
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show && this.props.show) {
      const v = ValidationHelper.getValidation(this.validationDefinition);
      // Send field'expiration' with default valur thorugh validator
      const validated = ValidationHelper.update(
        { target: { name: "expiration", value: v.expiration.value } },
        v,
      );
      this.setState({ validation: validated });
    }
  }

  onHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["userId"] = CamplaCoreService.getAuthenticatedUser()._id;
      this.props.onSubmit(validatedData);
    }
  }

  render() {
    const { t } = this.props;

    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        rightButtonCallback={this.onSubmit}
        title={t("Organisation.ApplicationTabbar.RenewTokenDialog.Title")}
        dialogApiError={this.props.dialogApiError}
        leftButtonVariant="black"
        rightButtonVariant="green"
        rightButtonText={t(
          "Organisation.ApplicationTabbar.RenewTokenDialog.Submit",
        )}
        leftButtonText={t(
          "Organisation.ApplicationTabbar.RenewTokenDialog.Cancel",
        )}
        leftButtonCallback={this.onHide}
        rightButtonDisabled={!this.state.validation._isValid}
        body={
          <Form>
            <Form.Group controlId="formDateEnd">
              <Form.Label>
                {t("Organisation.ApplicationTabbar.RenewTokenDialog.Label")}
              </Form.Label>
              <div>
                <BaseDatePicker
                  name="end"
                  className="form-control"
                  onChange={(d) => {
                    this.handleChange({
                      target: {
                        name: "expiration",
                        value: d,
                      },
                    });
                  }}
                  value={this.state.validation.expiration.value}
                  min={new Date()}
                />
              </div>
              <Form.Control
                type="hidden"
                isInvalid={!this.state.validation.expiration.isValid}
              />
              <Form.Control.Feedback type="invalid">
                {t(
                  "Organisation.ApplicationTabbar.RenewTokenDialog.ValidationError",
                )}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        }
      />
    );
  }
}

export default withTranslation()(RenewTokenDialog);
